/**
 * Platzhalter der HTML-Vorlagen: Text in eckigen Klammern und Großbuchstaben,
 * z. B. [DATUM] oder [TITEL DES LEHRGANGS]. Gesucht wird nur im sichtbaren
 * Text (ohne Kopfbereich, Stile, Kommentare und Tags) — Brevo-Variablen in
 * {{ … }} zählen nicht.
 */
const PLATZHALTER = /\[[A-ZÄÖÜẞ][A-ZÄÖÜẞ0-9 .:,;·/–\-…?!()„“"']{2,120}\]/g;

export function sichtbarerText(html: string): string {
  return html
    .replace(/<head[\s\S]*?<\/head>/gi, ' ')
    .replace(/<!--[\s\S]*?-->/g, ' ')
    .replace(/<(style|script)[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&');
}

/** Alle übrig gebliebenen Platzhalter, jeder nur einmal. */
export function offenePlatzhalter(...texte: (string | null | undefined)[]): string[] {
  const funde = new Set<string>();
  for (const t of texte) {
    for (const m of sichtbarerText(t ?? '').matchAll(PLATZHALTER)) funde.add(m[0]);
  }
  return [...funde];
}
